import type { IListing } from '@bb/domain/dist/types';

const buildListingFullAddress = (line1: string, line2?: string) => `${line1}${line2 ? ` ${line2}` : ''}`;

export const buildGoogleMapsAddress = (listing: Partial<IListing>) => {
  // Google maps does not recognize CAN
  const countryMap = { CAN: 'Canada', USA: 'USA' };
  const country = countryMap[listing.country!];
  return encodeURIComponent(
    `${country}, ${listing.province}, ${listing.postal_code}, ${listing.city}, ${listing.line1}`,
  );
};

export default buildListingFullAddress;
